import { Collapse } from "antd";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_MILITARY_STATUS,
  LIST_OPTION_GENDER,
  LIST_OPTION_MILITARY_STATUS,
  LIST_OPTION_VOICE_RANGE,
} from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";

const ApplicantInfoTab = ({ data }: any) => {
  const { t, i18n } = useTranslation();
  const [linkImage, setLinkImage] = useState<any>(null);

  const profileData = {
    nickName: data?.user_profile?.nickname,
    fullName: data?.user_profile?.fullname,
    gender: data?.user_profile?.gender,
    birthdate: formatDateStringToKorea(
      data?.user_profile?.date_of_birth
    )?.split(" ")?.[0],
    phoneType: "Mobile",
    phoneNumber: data?.user_profile?.phone_number,
    email: data?.user_profile?.email,
    snsType: data?.user_profile?.socials[0]?.sns,
    snsUrl: data?.user_profile?.socials[0]?.url,
    height: data?.user_profile?.height,
    weight: data?.user_profile?.weight,
    national: data?.user_profile?.national,
    address: data?.user_address?.short_address,
    militaryStatus: data?.user_profile?.military_service,
    voiceRange: data?.user_profile?.vocal_range,
    introduction: data?.user_profile?.bio,
    image_url: data?.user_profile?.image_url,
    workingHistory: data?.user_work_experiences?.map((i: any) => {
      return {
        title: i?.title,
        details: [
          { label: "Title of the Work", value: i?.title },
          { label: "Role", value: i?.position },
          { label: "Venue", value: i?.organization },
          {
            label: "Start Date",
            value: formatDateStringToKorea(i?.start_date)?.split(" ")?.[0],
          },
          {
            label: "End Date",
            value: formatDateStringToKorea(i?.end_date)?.split(" ")?.[0],
          },
          {
            label: "Description",
            value: i?.description,
          },
        ],
      };
    }),
  };

  return (
    <Container className="p-3">
      <Row>
        <Col md="4">
          <Card>
            <CardBody className="text-center">
              <div className="text-center mb-3">
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    setLinkImage(
                      (prev: any) => profileData?.image_url ?? avatar1
                    )
                  }
                >
                  <img
                    src={profileData?.image_url ?? avatar1}
                    className="rounded-circle avatar-lg"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div>
              </div>
              <CardTitle tag="h5">{profileData.nickName}</CardTitle>
              {profileData.email}
            </CardBody>
            <ListGroup flush>
              <ListGroupItem>{t('Full Name')}: {profileData.fullName}</ListGroupItem>
              <ListGroupItem>
                {t('Gender')}: {' '} 
                {t(
                  LIST_OPTION_GENDER.find((i) => i.value == profileData.gender)
                    ?.label || "-"
                )}
              </ListGroupItem>
              <ListGroupItem>{t('Birthdate')}: {profileData.birthdate}</ListGroupItem>
            </ListGroup>
          </Card>
        </Col>
        <Col md="8">
          <Card>
            <CardBody>
              <CardTitle tag="h5">{t('Personal Information')}</CardTitle>
              <Row>
                <Col md="12">
                  <ListGroup flush>
                    <ListGroupItem className="d-flex" style={{ gap: "2%" }}>
                      <div style={{ minWidth: "49%" }}>
                        <div>{t('Phone Type')}: {profileData.phoneType}</div>
                        <div className="mt-1">
                          {" "}
                          {t('Phone Number')}: {profileData.phoneNumber}
                        </div>
                      </div>

                      <div style={{ minWidth: "49%" }}>
                        <div>{t('SNS Type')}: {profileData.snsType}</div>
                        <div className="mt-1">
                          {t('SNS URL')}:{" "}
                          <a
                            href={profileData.snsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {profileData.snsUrl}
                          </a>
                        </div>
                      </div>
                    </ListGroupItem>

                    <ListGroupItem className="d-flex" style={{ gap: "2%" }}>
                      <div style={{ minWidth: "49%" }}>
                        {t('Height')}: {profileData.height}
                      </div>

                      <div style={{ minWidth: "49%" }}>
                        {t('Weight')}: {profileData.weight}
                      </div>
                    </ListGroupItem>

                    <ListGroupItem>
                      <div>{t('National')}: {profileData.national}</div>
                      <div className="mt-1">{t('Address')}: {profileData.address}</div>
                    </ListGroupItem>

                    <ListGroupItem className="d-flex" style={{ gap: "2%" }}>
                      <div style={{ minWidth: "49%" }}>
                        {t('Military Status')}:{" "}
                        <span
                          className={`rounded-pill badge bg-${
                            COLOR_MILITARY_STATUS[profileData.militaryStatus] ||
                            "secondary"
                          }`}
                        >
                          {t(
                            LIST_OPTION_MILITARY_STATUS?.find(
                              (i: any) =>
                                String(i?.value) ===
                                String(profileData.militaryStatus)
                            )?.label || ""
                          )}
                        </span>
                      </div>

                      <div style={{ minWidth: "49%" }}>
                        {t('Voice Range')}:{" "}
                        {
                          LIST_OPTION_VOICE_RANGE.filter(
                            (i: any) => i?.value == profileData?.voiceRange
                          )?.[0]?.label
                        }
                      </div>
                    </ListGroupItem>
                  </ListGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className="mt-3">
            <CardBody>
              <CardTitle tag="h5">{t('Introduce')}</CardTitle>
              <p>{profileData.introduction}</p>
            </CardBody>
          </Card>

          <div className="mt-3">
            <CardTitle tag="h5" className="mb-3">
              {t('Working History')}
            </CardTitle>
            {profileData?.workingHistory?.map(
              (historyItem: any, index: any) => (
                <div key={index} className="mb-3">
                  <Collapse
                    expandIconPosition="end"
                    items={[
                      {
                        key: "1",
                        label: `${historyItem?.title || "_"} | ${
                          historyItem?.details?.[1]?.value || "_"
                        } | ${historyItem?.details?.[3]?.value || "_"} | ${
                          historyItem?.details?.[4]?.value || "_"
                        }`,
                        children: (
                          <div
                            id="customerList"
                            style={{
                              boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
                              margin: 0,
                              background: "#F8F8F8",
                            }}
                          >
                            <ListGroup flush>
                              {historyItem?.details?.map(
                                (detail: any, detailIndex: any) => (
                                  <ListGroupItem key={detailIndex}>
                                    <strong>{t(detail?.label)}:</strong>{" "}
                                    {detail?.value}
                                  </ListGroupItem>
                                )
                              )}
                            </ListGroup>
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              )
            )}
          </div>
        </Col>
      </Row>

      <ModalPreview
        type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
        isOpen={!!linkImage}
        url={linkImage}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />
    </Container>
  );
};

export default ApplicantInfoTab;
